import { createSelector } from '@reduxjs/toolkit'
import { RootState } from '../../store'
import { appNames, isVMiQ } from 'utils/constants'
import { IWorkbook, IWorkbookTab  } from 'utils/constants/interfaces'

const selectmain = (state: RootState) => state.main
const state = (state: RootState) => state

const selectWorkbookListItems = createSelector(state, (root:any) => {
  return root.auth.user?.subscriptions[root.main.selectedSuscriptionIndex].workbooks
})

const selectWorkbookTier = createSelector(state, (root: any) => {
  const workbookGuid = root.main.selectedWorkbookGuid
  return root.auth.user.subscriptions[root.main.selectedSuscriptionIndex].workbooks.find((wb: IWorkbook)=>wb.workbookGuid === workbookGuid)?.groupTier
})

const selectHeaderTabs = createSelector(state, (root: any) => {
  const compareFn = (a: any, b: any) => a.groupOrder - b.groupOrder;

  const subscription = root.auth.user?.subscriptions[root.main.selectedSuscriptionIndex];
  const userWorkBooks = Array.isArray(subscription?.workbooks) ? [...subscription.workbooks] : [];

  const workbooks = userWorkBooks.sort(compareFn);

  const result = workbooks
    .filter((wb: any) =>
      isVMiQ
        ? wb.groupString.toUpperCase() === 'VMIQ'
        : wb.groupString.toUpperCase() !== 'VMIQ'
    )
    .reduce((acc: any, curr: any) => {
      let groupString;
      if (curr.groupString.toUpperCase() === 'VMIQ') {
        groupString = 'VMiQ';
      } else {
        groupString = curr.groupString.charAt(0) + curr.groupString.slice(1).toLowerCase();
      }

      if (
        groupString === 'Undefined' ||
        acc.find((g: any) => g.groupString === groupString)
      ) {
        return acc;
      }
      return [...acc, { ...curr, groupString }];
    }, []);

  return result;
});

/** Lista plana de workbooks para el header: un tab por workbook (sin agrupar). */
const selectHeaderWorkbooks = createSelector(state, (root: any) => {
  const subscription = root.auth.user?.subscriptions[root.main.selectedSuscriptionIndex];
  const userWorkBooks = Array.isArray(subscription?.workbooks) ? [...subscription.workbooks] : [];
  const compareFn = (a: any, b: any) =>
    a.groupOrder !== b.groupOrder ? a.groupOrder - b.groupOrder : a.tabGroupOrder - b.tabGroupOrder;
  return userWorkBooks
    .filter((wb: any) =>
      isVMiQ
        ? wb.groupString?.toUpperCase() === 'VMIQ'
        : wb.groupString?.toUpperCase() !== 'VMIQ'
    )
    .sort(compareFn);
});

const selectWorkbookHasApplyFilter = createSelector(state, (root: any) => {
  const workbookGuid = root.main.selectedWorkbookGuid;
  const subscription = root.auth.user.subscriptions[root.main.selectedSuscriptionIndex];
  const workbook = subscription.workbooks.find((wb: IWorkbook) => wb.workbookGuid === workbookGuid);
  return workbook?.hasApplyFilter === true;
});

const selectWorkbookAllowedFormats = createSelector(state, (root: any) => {
  const workbookGuid = root.main.selectedWorkbookGuid;
  const workbook = root.auth.user.subscriptions[root.main.selectedSuscriptionIndex].workbooks
    .find((wb: IWorkbook) => wb.workbookGuid === workbookGuid);

  const defaults = ['pdf', 'csv', 'xlsx'];

  const formats = workbook?.downloadFormatsAvailableIsActive
    ? workbook.downloadFormatsAvailable ?? []
    : defaults;

  return {
    pdf: formats.includes('pdf'),
    csv: formats.includes('csv'),
    xlsx: formats.includes('xlsx'),
  };
});



const selectWorkbookTabs = createSelector(
  state,
  (root: any): IWorkbookTab[] => {
  const compareFn = (a: any, b: any) => a.tabGroupOrder - b.tabGroupOrder;
  const selectedWorkbookGroup = root.main.selectedWorkbookGroup;
  const subscription = root.auth.user?.subscriptions[root.main.selectedSuscriptionIndex];
  const allWorkbooks = Array.isArray(subscription?.workbooks) ? subscription.workbooks : [];

  const filteredWorkbooks = allWorkbooks.filter(
    (wb: any) => wb.groupString === selectedWorkbookGroup?.toUpperCase()
  );

  return filteredWorkbooks
    .sort(compareFn)
    .map((wb: any) => ({
      workbookGuid: wb.workbookGuid,
      tabLabel: wb.workbookDisplayName,
    }));
});

const mainSelectors = {
  selectmain,
  selectHeaderTabs,
  selectHeaderWorkbooks,
  selectWorkbookTabs,
  selectWorkbookListItems,
  selectWorkbookTier,
  selectWorkbookHasApplyFilter,
  selectWorkbookAllowedFormats,
}

export default mainSelectors